// frontend/src/pages/admin/Login.jsx
import { useState } from 'react';
import { login } from '../../lib/api';
import { C, inp, lbl, Btn, ErrBox } from '../../components/UI';

export default function Login({ onLogin }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [show,     setShow]     = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const d = await login(email, password);
      localStorage.setItem('akcoda_token', d.token);
      localStorage.setItem('akcoda_email', d.email);
      onLogin(d.email);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: 'radial-gradient(circle, rgba(64,61,212,0.12) 0%, transparent 70%)', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', pointerEvents: 'none' }} />
      <div style={{ width: '100%', maxWidth: 420, position: 'relative' }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 58, height: 58, borderRadius: 17, background: 'linear-gradient(135deg,#403DD4,#6a68e8)', marginBottom: 18, boxShadow: `0 8px 32px ${C.brandGlow}` }}>
            <span style={{ fontSize: 26 }}>⚡</span>
          </div>
          <div style={{ fontSize: 28, fontWeight: 800, color: C.text, letterSpacing: '-0.5px' }}>AKCODA</div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 5 }}>Sign in to your admin panel</div>
        </div>
        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 20, padding: '32px 36px', boxShadow: '0 24px 64px rgba(0,0,0,0.4)' }}>
          <ErrBox msg={error} />
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 18 }}>
              <label style={lbl}>Email address</label>
              <input style={inp()} type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="admin@akcoda.com" required autoFocus
                onFocus={e => e.target.style.borderColor = C.brand}
                onBlur={e => e.target.style.borderColor = C.border} />
            </div>
            <div style={{ marginBottom: 28 }}>
              <label style={lbl}>Password</label>
              <div style={{ position: 'relative' }}>
                <input style={{ ...inp(), paddingRight: 44 }} type={show ? 'text' : 'password'}
                  value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
                  onFocus={e => e.target.style.borderColor = C.brand}
                  onBlur={e => e.target.style.borderColor = C.border} />
                <button type="button" onClick={() => setShow(!show)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: C.muted, cursor: 'pointer', fontSize: 16 }}>
                  {show ? '🙈' : '👁'}
                </button>
              </div>
            </div>
            <Btn type="submit" size="lg" disabled={loading} style={{ width: '100%', justifyContent: 'center', boxShadow: `0 4px 20px ${C.brandGlow}` }}>
              {loading ? 'Signing in…' : 'Sign In →'}
            </Btn>
          </form>
        </div>
        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: C.muted }}>Contract Management Platform · agreement.akcoda.in</div>
      </div>
    </div>
  );
}
